import { Alert } from "@kyan/ui";

import { useCloudflareWarningController } from "./CloudflareWarning.controller";

export const CloudflareWarning: React.FC = () => {
  const { isInvisible, description, dismiss } =
    useCloudflareWarningController();

  if (isInvisible) return null;

  return (
    <Alert
      className="p-4"
      variant="notice"
      title="Industry Outage"
      description={description}
      closeIconProps={{
        onClick: dismiss,
      }}
    />
  );
};
